import React, { useEffect, useReducer } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { BrowserRouter } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import useMedia from 'use-media';

import { AppContext } from 'src/containers/Core/AppContext';
import { initialState, reducer } from 'src/containers/Core/AppReducer';
import { AppViewContext } from 'src/containers/Core/AppView';
import ErrorBoundary from 'src/containers/Core/ErrorBoundary';
import Routes from 'src/containers/Core/Routes';
import { connectPusher, disconnectPusher } from 'src/utils/pusher';

import 'src/assets/styles/_main.scss';

const App = () => {
  const isPhoneView = useMedia({ 'max-width': '770px' });
  const isTabView = useMedia({ 'min-width': '768px', 'max-width': '899px' });

  useEffect(() => {
    connectPusher();

    return () => {
      disconnectPusher();
    };
  }, []);

  const [store, dispatch] = useReducer(reducer, initialState);

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ToastContainer
          position={toast.POSITION.TOP_RIGHT}
          autoClose={5000}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          draggable
          pauseOnHover={false}
        />
        <AppViewContext.Provider value={{ isPhoneView, isTabView }}>
          <AppContext.Provider
            value={{
              store,
              dispatch,
            }}
          >
            <Routes />
          </AppContext.Provider>
        </AppViewContext.Provider>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default App;
